module.exports = __webpack_public_path__ + "images/Preview _No_interactions.svg";